// extracted by mini-css-extract-plugin
export default {"logo":"NavbarBrand_logo__sFs9F"};